import * as React from "react";
import { forwardRef } from "react";
const SvgCollapseArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 23, height: 23, viewBox: "0 0 23 23", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(.5 .5)" }, /* @__PURE__ */ React.createElement("circle", { cx: 11, cy: 11, r: 11, fill: "#FFF", stroke: "#E3E3E3" }), /* @__PURE__ */ React.createElement("path", { fill: "#363636", d: "M10.625 14.908L6.44 10.164a.5.5 0 0 1 .375-.83h8.372a.5.5 0 0 1 .375.83l-4.186 4.744a.5.5 0 0 1-.75 0z" })));
const ForwardRef = forwardRef(SvgCollapseArrow);
export default ForwardRef;
